"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _models = _interopRequireDefault(require("../utils/models"));

var _entities = require("../actions/entities");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Redux Entity Model, that abstracts common API CRUD actions
 * @param {Object}
 * @constructor
 */
var EntityModel = /*#__PURE__*/function () {
  function EntityModel(_ref) {
    var modelName = _ref.modelName,
        _ref$initialState = _ref.initialState,
        initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
        _ref$selectors = _ref.selectors,
        selectors = _ref$selectors === void 0 ? {} : _ref$selectors,
        _ref$actionCreators = _ref.actionCreators,
        actionCreators = _ref$actionCreators === void 0 ? {} : _ref$actionCreators,
        config = _ref.config;
    (0, _classCallCheck2.default)(this, EntityModel);
    var entityActionCreators = this.getActionCreators(modelName, config, actionCreators);
    var entitySelectors = this.getSelectors(modelName, selectors);

    var entityState = _lodash.default.merge({}, EntityModel.initialState, initialState);

    var model = (0, _models.default)({
      modelName: modelName,
      actionCreators: entityActionCreators,
      selectors: entitySelectors,
      initialState: entityState,
      config: config
    }); // HACK: Special selectors that let you connect to a specific record/list,
    //  passing in the item/list id in the meta information to be able to
    //  map the current state to props accordingly

    model.listSelectors = function (state, props, id) {
      return model.selectors(state, props, {
        listId: id,
        itemId: null
      });
    };

    model.itemSelectors = function (state, props, id) {
      return model.selectors(state, props, {
        listId: null,
        itemId: id
      });
    };

    model.__entityModel = true;
    return model;
  }

  (0, _createClass2.default)(EntityModel, [{
    key: "getActionCreators",
    value: function getActionCreators(modelName, config, customActionCreators) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _entities.getCrudActionCreators)(modelName, config)), (0, _entities.getLocalActionCreators)(modelName, config)), (0, _entities.getConsumerActionCreators)(modelName, config)), customActionCreators);
    }
  }, {
    key: "getSelectors",
    value: function getSelectors(modelName, customSelectors) {
      var _objectSpread2;

      return _objectSpread((_objectSpread2 = {}, (0, _defineProperty2.default)(_objectSpread2, _entityNormalizer.ITEM, function (state, props, _ref2) {
        var itemId = _ref2.itemId,
            fields = _ref2.fields;
        return itemId ? (0, _entityNormalizer.memGetEntityItem)(state, modelName, itemId, fields) : undefined;
      }), (0, _defineProperty2.default)(_objectSpread2, _entityNormalizer.LIST, function (state, props, _ref3) {
        var listId = _ref3.listId,
            fields = _ref3.fields;
        return listId ? (0, _entityNormalizer.memGetEntityList)(state, modelName, listId, fields) : undefined;
      }), _objectSpread2), customSelectors);
    }
  }]);
  return EntityModel;
}();

exports.default = EntityModel;
(0, _defineProperty2.default)(EntityModel, "initialState", (0, _entityNormalizer.getDefaultState)());